import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Heading from '../../../generic-components/Heading';
import { TEXT, STYLES } from '../../planUpgrade/constants';
import Button from '../../../generic-components/Button';
import { PlanUpgradeFlow } from '../../planUpgrade';
import { ReactComponent as RightArrow } from '../../../assets/icons/svg/shared/ic-shared-right-arrow.svg';
import { VIEWS_MAP } from '../../../router/constants';

const { INDEX: { PROMOTIONS: { PROFILE } } } = STYLES;

interface IProps {
    planType: string;
    shouldImmediatelyInvoke?: boolean
    shouldAppearAsButton?: boolean;
    customTitle?: string;
    buttonClassName?: string;
    testId?: string;
}
export const ProfilePlanPromotion = ({
  planType, shouldAppearAsButton, customTitle, shouldImmediatelyInvoke, buttonClassName, testId,
}: IProps) => {
  const [isPlansPopupPresented, setIsPlansPopupPresented] = useState<boolean>(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const titleMap = {
    BASIC: TEXT.PROFILE.TYPES.BASIC.TITLE,
    BASIC_V2: TEXT.PROFILE.TYPES.BASIC.TITLE,
    PRO: TEXT.PROFILE.TYPES.PRO.TITLE,
    PRO_V2: TEXT.PROFILE.TYPES.PRO.TITLE,
    SMART: TEXT.PROFILE.TYPES.SMART.TITLE,
  };

  const subtitleMap = {
    BASIC: TEXT.PROFILE.TYPES.BASIC.SUBTITLE,
    BASIC_V2: TEXT.PROFILE.TYPES.BASIC.SUBTITLE,
    PRO: TEXT.PROFILE.TYPES.PRO.SUBTITLE,

    PRO_V2: TEXT.PROFILE.TYPES.PRO.SUBTITLE,
    SMART: TEXT.PROFILE.TYPES.SMART.SUBTITLE,
  };
  const dynamicTitle = useMemo(() => titleMap[planType as keyof typeof titleMap], [planType]);
  const dynamicSubtitle = useMemo(() => subtitleMap[planType as keyof typeof subtitleMap], [planType]);

  useEffect(() => {
    if (shouldImmediatelyInvoke) setIsPlansPopupPresented(true);
  }, []);

  return (
    <Button
      testId={testId}
      childElement={(
        <div className={shouldAppearAsButton ? buttonClassName || PROFILE.AS_BUTTON_LAYOUT : PROFILE.LAYOUT}>
          {!shouldAppearAsButton && (
          <div className={PROFILE.TEXTS_CONTAINER}>
            <Heading id='upgradeToInfo' title={t(dynamicTitle)} className={PROFILE.TITLE} />
            <Heading id='upgradeSubTitle' title={t(dynamicSubtitle)} className={PROFILE.SUBTITLE} />
          </div>
          )}

          {!shouldAppearAsButton && <RightArrow className={PROFILE.ARROW} />}
          {shouldAppearAsButton && <Heading title={customTitle || ''} className='' />}
          { isPlansPopupPresented && (

            <PlanUpgradeFlow
              onCloseClick={() => { setIsPlansPopupPresented(false); navigate(`/${VIEWS_MAP.DASHBOARD}`); }}
              origin='Plan Promotion'
              promotionType='Personal Details'
            />
          )}
        </div>
                  )}
      className={shouldImmediatelyInvoke ? 'invisible' : 'justify-start w-full'}
      id='upgradePlanButton'
      onClick={() => setIsPlansPopupPresented(!isPlansPopupPresented)}
    />
  );
};
